import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../context/useLanguage";
import { getUserInfo } from "../../api/support";
import { UserPurchasesResponse } from "../../types/types";
import { ModalPortal } from "./ModalPortal";
import styles from "./CompanyEditModal.module.css";

interface UserEditModalProps {
    userId: string;
    isOpen: boolean;
    onClose: () => void;
}

const UserEditModal: React.FC<UserEditModalProps> = ({ userId, isOpen, onClose }) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const [activeTab, setActiveTab] = useState<"tracks" | "cities" | "info">("info");
    const { language } = useLanguage();
    const [loading, setLoading] = useState<boolean>(false);
    const [userInfo, setUserInfo] = useState<UserPurchasesResponse | null>(null);

    console.log("UserEditModal:", userInfo);

    useEffect(() => {
        if (isOpen && userId) {
            fetchUserInfo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, userId, language]);

    const fetchUserInfo = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                console.error("Token not found");
                return;
            }
            const response = await getUserInfo(token, userId);
            setUserInfo(response);
        } catch (error) {
            console.error("Failed to fetch cities", error);
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    const purchases = userInfo?.purchases || [];

    return (
        <ModalPortal>
            <div className={styles.overlay}>
                <div className={styles.content}>
                    <h2>{t("userPurchaseInfo")}</h2>

                    <div className={styles.tabs}>
                        <button
                            className={`${styles.tab}${activeTab === "info" ? ` ${styles.tabActive}` : ""}`}
                            onClick={() => setActiveTab("info")}
                        >
                            {t("info")}
                        </button>
                    </div>

                    {activeTab === "info" && (
                        <div>
                            <h4>{t("purchases")}</h4>
                            {loading ? (
                                <p>{t("loading")}</p>
                            ) : (
                                <table className={styles.table}>
                                    <thead>
                                        <tr>
                                            <th>{t("trackName")}</th>
                                            <th>{t("externalPurchaseId")}</th>
                                            <th>{t("purchaseDate")}</th>
                                            <th>{t("seenWaypoints")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {purchases.map((purchase) => (
                                            <tr key={purchase.trackId}>
                                                <td>{purchase.trackName}</td>
                                                <td>{purchase.externalPurchaseId}</td>
                                                <td>{purchase.purchaseDate}</td>
                                                <td>
                                                    {purchase.seenWaypoints.length === 0 ? (
                                                        <i>{t("noWaypointsSeen")}</i>
                                                    ) : (
                                                        <ul>
                                                            {purchase.seenWaypoints.map((wp) => (
                                                                <li key={wp.waypointId}>{wp.waypointName}</li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    )}
                    <div className={styles.footer}>
                        <button className={styles.buttonCancel} onClick={onClose}>
                            {t("close")}
                        </button>
                    </div>
                </div>
            </div>
        </ModalPortal>
    );
};

export default UserEditModal;
